/* The target pathway. Tokens only (ADR-0007); the marks take their colours from `chartTokens.ts`. */

.frame {
  width: 100%;
  min-width: 0;
}

.svg {
  display: block;
  max-width: 100%;
}

.legend {
  list-style: none;
  margin: 8px 0 0;
  padding: 0;
  display: grid;
  gap: 6px;
}

.legendRow {
  display: grid;
  grid-template-columns: 14px minmax(0, 1fr) auto;
  grid-template-areas:
    "glyph label value"
    ". basis basis";
  column-gap: 8px;
  align-items: baseline;
  font-size: var(--t-min);
  line-height: 1.4;
  min-width: 0;
}

.glyph {
  grid-area: glyph;
  align-self: center;
}

.legendLabel {
  grid-area: label;
  color: var(--ink);
  font-weight: 600;
  overflow-wrap: anywhere;
}

.legendValue {
  grid-area: value;
  color: var(--ink);
  white-space: nowrap;
}

.legendBasis {
  grid-area: basis;
  color: var(--muted);
}

.caption {
  margin: 10px 0 0;
  font-size: var(--t-min);
  line-height: 1.5;
  color: var(--muted);
  max-width: 80ch;
}

.cannot {
  margin: 0 0 8px;
  padding: 8px 10px;
  border: 1px dashed var(--line-2);
  border-radius: 7px;
  font-size: var(--t-min);
  line-height: 1.5;
  color: var(--ink-2);
}

/* The scenario picker: a group of toggle buttons, each at least the 24px target size. */
.picker {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 0 0 8px;
}

.pick {
  min-height: var(--target-min);
  padding: 2px 10px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-pill);
  background: var(--panel);
  color: var(--ink);
  font: inherit;
  font-size: var(--t-min);
  cursor: pointer;
}

.pick:hover {
  background: var(--panel-2);
}

.pick[aria-pressed="true"] {
  background: var(--info-w);
  border-color: var(--info);
  color: var(--info);
  font-weight: 600;
}

.pick:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 1px;
}
